module.exports = __webpack_public_path__ + "static/media/pure-natural-white.4c6d1e64.svg";